import { SCRIPT_TITLE_CLASSES } from './config';

interface ScaffoldSection {
  label: string;
  lines: string[];
}

/** The starter scaffold shown in an empty editor. Purely guidance (rendered as a
 *  Lexical placeholder), so it is never part of the submitted script. Beats are
 *  personalised with the creator's name. */
function scaffoldSections(creatorName: string): ScaffoldSection[] {
  const name = creatorName.trim() || 'the creator';
  return [
    { label: 'Hook (0–5s)', lines: ['One-liner that makes the viewer stop scrolling.'] },
    {
      label: 'Body',
      lines: [`Beat 1: ${name}'s natural intro`, 'Beat 2: product demo / story', 'Beat 3: payoff / proof point'],
    },
    { label: 'CTA', lines: ['Closing call-to-action; mention the brand name and link.'] },
  ];
}

/** Placeholder overlay for the blank editor. `pointer-events-none` so clicks fall
 *  through to the editor; Lexical hides it as soon as any content exists. */
export function ScriptScaffold({ creatorName }: { creatorName: string }) {
  return (
    <div className="pointer-events-none absolute inset-x-4 top-3 space-y-3 text-body-sm-regular text-muted-foreground">
      {/* No top margin so the title's first line aligns with the editor caret. */}
      <p className={SCRIPT_TITLE_CLASSES}>Your script title</p>
      {scaffoldSections(creatorName).map((section) => (
        <div key={section.label}>
          <p className="font-semibold">{section.label}</p>
          <ul className="my-2 list-disc pl-6">
            {section.lines.map((line) => (
              <li key={line} className="my-0.5">
                {line}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
